import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { updateChargingServiceMetadata } from '../../api/charging-service.ts';
import { UpdateChargingServiceMetadataRequest } from '../../api/requests/charging-service-request.ts';

export default function useUpdateChargingServiceMetadata(): UseMutationResult<
  Awaited<ReturnType<typeof updateChargingServiceMetadata>>,
  Error,
  UpdateChargingServiceMetadataRequest
> {
  return useMutation({
    mutationFn: updateChargingServiceMetadata,
  });
}
